/** Unread notifications within this window are included in the header bell count. */
export const BELL_UNREAD_DAYS = 30;

/** Maximum unread notifications shown in the bell dropdown. */
export const BELL_UNREAD_LIMIT = 25;

export const parseNotificationCount = (
  value: string | number | null | undefined
): number => {
  if (value == null) {
    return 0;
  }
  if (typeof value === "number") {
    return value;
  }
  const parsed = parseInt(String(value).replace(/,/g, ""), 10);
  return Number.isNaN(parsed) ? 0 : parsed;
};

export const formatBellBadgeCount = (count: number): number | string => {
  if (count > 99) {
    return "99+";
  }
  return count;
};
